<template>
  <div v-if="extData.tenderTermsId">
    <HkldDropzone
      v-if="allowEdit"
      :sourceId="extData.itqTermsId"
      :action="ActionTypes.settings.doc.itq.create"
      :metaData="{uploadOnTop: true}"
    />
    <EditTerms
      :sourceId="extData.itqTermsId"
      :canEdit="allowEdit"
      :canDelete="allowEdit"
      :canDownloadAll="false"
      :action="ActionTypes.settings.doc.itq.delete"
      :updateAction="ActionTypes.settings.doc.itq.edited"
    />
  </div>
</template>
<script>
import HkldDropzone from '@/controls/HkldDropzone'
import EditTerms from '@/controls/EditTerms'
import { ActionTypes } from '@/utils/consts'

export default {
  name: 'ITQ',
  components: {
    HkldDropzone, EditTerms,
  },
  model: {
    prop: 'extData',
    event: 'onChange',
  },
  props: {
    extData: Object,
    formOptions: Object,
  },
  data () {
    return {
      ActionTypes,
    }
  },
  computed: {
    allowEdit () {
      const { formOptions: options } = this
      return !options.readonly && (
        options.isAdmin ||
        options.hasSettingUpdateAccess ||
        options.hasDocuementUpdateAccess
      )
    },
  },
}
</script>
<style scoped lang="scss">
</style>
